import AbstractFormulaToken from "./AbstractFormulaToken.js";

/**
 * Abstract super class for all binary operators.
 */
export default class AbstractBinaryOperatorFormulaToken extends AbstractFormulaToken {
	precedence() {
		return 0;
	}

	isBinaryOperator() {
		return true;
	}

	accept(visitor) {
		return visitor.visitAbstractBinaryOperatorFormulaToken(this);
	}

	asFormulaNode(...args) {
		const constructor = this._formulaNodeConstructor();
		return new constructor(...args);
	}

	_formulaNodeConstructor() {
		this._subclassResponsibility();
	}
}
